import { render, staticRenderFns } from "./GoogleDrivePicker.vue?vue&type=template&id=efec7c14&scoped=true&"
import script from "./GoogleDrivePicker.vue?vue&type=script&lang=js&"
export * from "./GoogleDrivePicker.vue?vue&type=script&lang=js&"
import style0 from "./GoogleDrivePicker.vue?vue&type=style&index=0&id=efec7c14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efec7c14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('efec7c14')) {
      api.createRecord('efec7c14', component.options)
    } else {
      api.reload('efec7c14', component.options)
    }
    module.hot.accept("./GoogleDrivePicker.vue?vue&type=template&id=efec7c14&scoped=true&", function () {
      api.rerender('efec7c14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/knowledge/components/GoogleDrivePicker.vue"
export default component.exports